import CityPageTemplate from "../city-template/CityPageTemplate";
import { columbusInConfig } from "./data";

export default function ColumbusInPage() {
  return <CityPageTemplate config={columbusInConfig} />;
}